import cn from 'classnames';
import { List, type OnChangeMeta } from 'react-movable';
import { SortableListItem } from '#components/atoms/lists/sortable-list/SortableListItem.tsx';
import styles from './SortableList.module.css';

type Props = {
  /** Will be populated into sortable list items */
  rows: React.ReactNode[];
  /** Extra classNames to add to the list element */
  className?: string;
  onChange: (meta: OnChangeMeta) => void;
  /** Add some opacity and prevent further changes */
  isSaving?: boolean;
};

/**
 * Allows vertically rearranging the order of rows in a list
 */
export function SortableList({ rows, isSaving, onChange, className }: Props) {
  return (
    <List
      disabled={isSaving}
      values={rows}
      lockVertically={true}
      onChange={onChange}
      renderList={({ children, props }) => (
        <ul {...props} className={cn(className, styles.SortableList)}>
          {children}
        </ul>
      )}
      renderItem={({ value, props, isDragged, isDisabled }) => {
        const { key, ...otherProps } = props;
        return (
          <SortableListItem isDragging={isDragged} isDisabled={isDisabled} key={key} {...otherProps}>
            {value}
          </SortableListItem>
        );
      }}
    />
  );
}
